export const CANONICAL_ALLERGEN_CODES = Object.freeze([
  "egg",
  "fish",
  "gluten",
  "milk",
  "tree_nut",
  "peanut",
  "sesame",
  "shellfish",
  "soy",
]);

export const FOOD_DIETARY_SUITABILITY_OPTIONS = Object.freeze([
  "unknown",
  "none",
  "vegetarian",
  "vegan",
]);

export const USER_DIETARY_PREFERENCE_OPTIONS = Object.freeze([
  "none",
  "vegetarian",
  "vegan",
]);
